export function getRequestedCubeAttributeId(searchParams: URLSearchParams) {
  return searchParams.get("cubeAttributeId") || searchParams.get("chartMeasurmentId");
}

export function findCubeAttributeRowTarget(
  rows: Array<{ id?: unknown; rowid?: unknown }>,
  cubeAttributeId?: string | null
) {
  if (!cubeAttributeId) return null;

  const rowIndex = rows.findIndex((row) => String(row.id) === cubeAttributeId);
  if (rowIndex < 0) return null;

  const rowId = rows[rowIndex].rowid ?? rows[rowIndex].id;
  if (typeof rowId !== "string" && typeof rowId !== "number") return null;

  return { rowId, rowIndex };
}
